import React, { useEffect, useState } from "react";

import LayoutWrapper from "../../../common/LayoutWrapper";
import EmergencyFolder from "../../../components/documents/healthcare-proxy/EmergencyFolder";
import Signature from "../../../components/documents/healthcare-proxy/Signature";
import Guardian from "../../../components/documents/guardianship/Guardian";
import Wishes from "../../../components/documents/guardianship/Wishes";
import GetStarted from "../../../components/documents/careDirective/GetStarted";
import FoodDrink from "../../../components/documents/careDirective/FoodDrink";
import Clothing from "../../../components/documents/careDirective/Clothing";
import BodyCare from "../../../components/documents/careDirective/BodyCare";
import Other from "../../../components/documents/careDirective/Other";
import IndividualWishes from "../../../components/documents/careDirective/IndividualWishes";
import Overview from "../../../components/documents/careDirective/Overview";

import CloseSteps from "../../../common/Swipers/CareDirectivesSteps";

import { useSelector, useDispatch } from "react-redux";
import { customTab, nextTab, preTab } from "../../../redux/slices/TabSlices";
import { getAssetsOnBoardingList } from "../../../redux/slices/features/assetsOnBoardingSlice";
import { connect } from "react-redux";
import { resetCard } from "../../../redux/slices/CardSlices";
import { visited } from "../../../redux/slices/features/assetsOnBoardingSlice";
import { getSBText } from "../../../utils/suggestionBoxUtilities";
import { careDirectiveSteps } from "../../../constants/constants";
import {
  LinkButton,
  PrimaryButton,
  SecondaryButton,
} from "../../../common/Buttons";
import DocSwiper from "../../../common/Swipers/DocsSwiper";

import "../../../components/yourAssets/BOA/BOA.scss";
import {
  getCareDirectiveData,
  setCareDirectiveData,
} from "../../../services/documentServices";
import {
  getDateFromDateStamp,
  getTimeFromDateStamp,
  getUserIdFromLocalStorage,
  overAllStatus,
  changeUpdateFormat,
} from "../../../utils/Utilities";
import { useTranslation } from "react-i18next";
import { updateStatusQuoAuditTrails } from "../../../services/auditTrails";
import ModifiedByToaster from "../../../common/ModifiedByToaster";

const CareDirective = ({
  currentTab,
  nextTab,
  preTab,
  customTab,
  resetCard,
  updates,
}) => {
  const { t, i18n } = useTranslation();
  let uID = getUserIdFromLocalStorage();
  let currentConsultantId = localStorage.getItem("currentConsultantId");
  const [steps, setSteps] = useState(careDirectiveSteps);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [data, setData] = useState(null);
  const handleResetCard = () => {
    resetCard();
  };
  const handleNext = () => {
    handleResetCard();
    nextTab();
  };
  const handleBack = () => {
    handleResetCard();
    preTab();
  };
  const handleCustomTab = (val) => {
    customTab(val);
  };
  const handleUpdatesTrails = async () => {
    const result = await updateStatusQuoAuditTrails(
      updates.map((item) => item.auditTrailId),
      currentConsultantId
    );
  };
  useEffect(() => {
    handleUpdatesTrails();
  }, []);
  const tabMaping = {
    1: (
      <GetStarted
        next={handleNext}
        pre={handleBack}
        setButtonDisabled={setButtonDisabled}
      />
    ),
    2: (
      <FoodDrink
        next={handleNext}
        pre={handleBack}
        setButtonDisabled={setButtonDisabled}
      />
    ),
    3: (
      <Clothing
        next={handleNext}
        pre={handleBack}
        setButtonDisabled={setButtonDisabled}
      />
    ),
    4: (
      <BodyCare
        next={handleNext}
        pre={handleBack}
        setButtonDisabled={setButtonDisabled}
      />
    ),
    5: (
      <Other
        next={handleNext}
        pre={handleBack}
        setButtonDisabled={setButtonDisabled}
      />
    ),
    6: (
      <IndividualWishes
        next={handleNext}
        pre={handleBack}
        setButtonDisabled={setButtonDisabled}
      />
    ),
    7: (
      <Overview
        next={handleNext}
        pre={handleBack}
        setButtonDisabled={setButtonDisabled}
      />
    ),
  };
  const dispatch = useDispatch();
  const tabStatuses = useSelector(
    (state) => state.assetsOnBoarding.assetsSuggestionBoxText
  );

  async function fetchData() {
    const arr = [];
    const result = await getCareDirectiveData(uID);
    if (result?.success) {
      if (result.payLoad && Object.keys(tabMaping).length === currentTab) {
        setData(result.payLoad);
      }
      const {
        foodDrink,
        cloth,
        bodyCare,
        otherCareDirective,
        startedStepStatus,
      } = result.payLoad;

      const array = [
        startedStepStatus,
        foodDrink?.stepStatus || 0,
        cloth?.stepStatus || 0,
        bodyCare?.stepStatus || 0,
        otherCareDirective?.stepStatus || 0,
        2,
        2,
      ];

      steps.forEach((elem, index) => {
        if (index !== steps.length - 1) {
          arr.push({ ...elem, stepStatus: array[index] });
        }
        if (index === steps.length - 1) {
          const res = overAllStatus(array);
          arr.push({ ...elem, stepStatus: res ? 2 : 1 });
        }
      });

      setSteps(arr);
    }
  }

  useEffect(() => {
    fetchData();
  }, [currentTab]);

  useEffect(() => {
    dispatch(getAssetsOnBoardingList());
  }, []);

  const renderTab = () => {
    return (
      <>
        {tabMaping[currentTab]}
        {updates.length > 0 && (
          <ModifiedByToaster
            title={`${t("modified-by")} ${updates[0]?.username}` || ""}
            subTitle={` ${changeUpdateFormat(
              updates[0]?.updatedTime,
              i18n.language
            )}`}
          />
        )}
      </>
    );
  };
  return (
    <>
      <LayoutWrapper
        borderShadow={true}
        minHeight="calc(100vh - 100px) !important"
      >
        <DocSwiper
          tab={currentTab}
          showTooltip={false}
          back={handleBack}
          custom={handleCustomTab}
          list={steps}
          data={data}
          handleSubmitStatus={
            Object.keys(tabMaping).length === currentTab
              ? setCareDirectiveData
              : null
          }
        />

        {renderTab()}

        {currentTab !== 7 ? (
          <div
            style={{
              minWidth: "310px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <SecondaryButton
              title={t("save-and-continue")}
              bgColor="#E8D7E5"
              borderRadius="14px"
              width="180px"
              marginLeft="20px"
              border="none"
              hoverBgColor="color.magentaLight1"
              textTransform="initial"
              padding="0rem"
              height="2.7rem"
              form="form_submit"
              type="submit"
              disabled={buttonDisabled}
            />

            <LinkButton
              title={t("skip-for-now")}
              bgColor="color.transparent"
              borderRadius="14px"
              fontSize="0.8rem"
              width="150px"
              marginLeft="10px"
              padding="0"
              border="none"
              click={handleNext}
              textTransform="initial"
            />
          </div>
        ) : (
          <div
            className="button-container-2"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <PrimaryButton
              title={t("save")}
              bgColor="#E8D7E5"
              color="#444561"
              padding="10px 60px"
              textTransform="initial"
              borderRadius={"18px"}
              boxShadow={0}
            />
          </div>
        )}
      </LayoutWrapper>
    </>
  );
};

function mapStateToProps(state) {
  return {
    currentTab: state.currentTab.currentTab,
    updates: state.statusQuoDocuments.updates.careDirective,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    nextTab: () => dispatch(nextTab()),
    preTab: () => dispatch(preTab()),
    customTab: (num) => dispatch(customTab(num)),
    resetCard: () => dispatch(resetCard()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CareDirective);
